"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreviousUrlFromStorage = exports.createHistoryStorage = void 0;
var CURRENT_PAGE = 'currentPage';
var PREVIOUS_PAGE = 'previousPage';

var createHistoryStorage = function createHistoryStorage(pathname) {
  var previousPage = sessionStorage.getItem(CURRENT_PAGE);

  if (previousPage && previousPage !== pathname) {
    sessionStorage.setItem(PREVIOUS_PAGE, sessionStorage.getItem(CURRENT_PAGE));
  }

  sessionStorage.setItem(CURRENT_PAGE, pathname);
};

exports.createHistoryStorage = createHistoryStorage;

var getPreviousUrlFromStorage = function getPreviousUrlFromStorage() {
  return sessionStorage.getItem(PREVIOUS_PAGE);
};

exports.getPreviousUrlFromStorage = getPreviousUrlFromStorage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/dist/utils/history.js
// module id = 646
// module chunks = 33